
import Vue from 'vue';
import {
	RUNNIT_NODE_DEF_TAG_TYPE,
	RunnitNodeDefTag,
} from '@run-diffusion/shared';
import { mapState } from 'vuex';
import { TRAINING_TYPE_CARDS } from "@/views/Runnits/constants";

export default Vue.extend({
	name: 'ModelTagTypeSelect',
	props: {
		selectedTypes: { type: Array, default: () => [] },
		isAllCategorySelected: { type: Boolean, default: false },
	},
	data () {
		return {
			RUNNIT_NODE_DEF_TAG_TYPE,
		};
	},
	computed: {
		...mapState([
			'publicRunnitNodeDefTags'
		]),
		items () {
			return this.publicRunnitNodeDefTags
				.filter((tag: RunnitNodeDefTag) => tag.type === RUNNIT_NODE_DEF_TAG_TYPE.TRAINING_TYPE)
				.map((tag: RunnitNodeDefTag) => ({
					id: tag.id,
					label: TRAINING_TYPE_CARDS[tag.id].title,
					icon: TRAINING_TYPE_CARDS[tag.id].icon,
				}));
		},
		selectedTypesMap () {
			return this.selectedTypes.reduce((map: Record<string, boolean>, tagId: string) => ({
				...map,
				[tagId]: true,
			}), {});
		},
	},
	methods: {
		onSelectAllCategory () {
			this.$emit('on-all-category-selected');
		},
		handleOptionSelection (selectedItem) {
			let selectedTypes: string[] = [...this.selectedTypes];

			if (this.isAllCategorySelected) {
				selectedTypes = [];
			}

			if (selectedTypes.includes(selectedItem.id)) {
				selectedTypes = selectedTypes.filter((tagId: string) => tagId !== selectedItem.id);
			} else {
				selectedTypes = [selectedItem.id];
			}

			if (!selectedTypes.length) {
				this.onSelectAllCategory();
			} else {
				this.$emit('on-select', selectedTypes);
			}
		},
	},
});
